import * as React from 'react';
import { Dropdown } from 'semantic-ui-react';

interface Props {
    input: {
        value: number | string,
        onChange: Function
    };
    options: {
        key: number | string,
        value: number | string
    }[];
}

export class TableCellRenderDropdown extends React.PureComponent<Props> {
    componentDidUpdate(prevProps: Props) {
        const {
            input: { value, onChange },
            options
        } = this.props;

        // Clear input value if it doen't exist in options
        if (
            value &&
            !options.some(
                option => option.key === value || option.value === value
            )
        ) {
            onChange(null);
        }
    }

    render() {
        const {
            input: { value, ...input },
            options
        } = this.props;

        return (
            <Dropdown
                {...input}
                options={options}
                value={value}
                onChange={(param, data) => {
                    input.onChange(data.value);
                }}
                onBlur={event => event.preventDefault()}
                icon={null}
                fluid
                search
                lazyLoad
            />
        );
    }
}

export default TableCellRenderDropdown;
